import axios from "axios";

export const getSection5 = async () => {
  return await axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/api/about-page-s5-leadership?populate[Head][populate]=*&populate[Pre_clinical][populate]=*&populate[External_Partnering][populate]=*`,
    )
    .then((response) => response.data)
    .catch((error) => error);
};
